import { render, staticRenderFns } from "./CreateNewPass.vue?vue&type=template&id=5c7d5a88&"
import script from "./CreateNewPass.vue?vue&type=script&lang=js&"
export * from "./CreateNewPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateNewPass.vue"
export default component.exports